import {Enviroment} from '../../../../_config/constants/enviroment-v2.constant'

export const platformNames = {
    mkt: 'Marketplace',
    ecc: 'Ecommerce',
    tirxs: 'Tirxs',
    benestarx: 'Benestarx',
    pharol: 'pharol',
};

export const nameAdapter = (pharmacy) => {
    if (pharmacy === platformNames.pharol) {
        if (Enviroment.COUNTRY === 'MX') {
            return `${platformNames.mkt} ${platformNames.benestarx}`;
        }
        else {
            return `${platformNames.mkt} ${platformNames.tirxs}`;
        }
    }
    return `${platformNames.ecc} ${pharmacy}`;
};